import useEdgeDataFetcher from './useEdgeDataFetcher'
import { useState, useEffect } from 'react'
import { checkIneligibleYear, getMatchingTrim } from '../utils/vehicleUtils'

export default (landingContext, vin, trim, submitVinCount, fromPlate, updateGlobalState, cadsBypassFlag, vinVerifiedFlag, fromAuction, cancelRequest = false) => {
  const [vinResults, setVinResults] = useState(undefined)
  const [cadsFlags, setCadsFlags] = useState(undefined)
  const isOfferExpired = landingContext.offer && (landingContext.offer.status === 'EXPIRED' || landingContext.offer.isExpired)
  const isAdmin = landingContext.experienceState.isAdmin

  const [posData, vinErrors, vinIsFetching] = useEdgeDataFetcher(vin && (isAdmin || !isOfferExpired) && `/vehicles/vin/${vin}/?cadsBypass=${cadsBypassFlag}&vinVerified=${vinVerifiedFlag}&fromAuction=${fromAuction}`, ...Array(8), cancelRequest) //hit vavin for auction verification
  const svocIdParameter = landingContext.experienceState.dealerId ? `?svocId=${landingContext.experienceState.dealerId}&a=b` : '?a=b'
  const [vinActiveDealer, , vinActiveDealerIsFetching] = useEdgeDataFetcher(vin && `/vin/activeautotraderlisting/${vin}${svocIdParameter}`, ...Array(8), cancelRequest)
  const [vehicleTypical, ,] = useEdgeDataFetcher(trim && `/vehicles/typicalmileage?trimId=${trim}`, ...Array(8), cancelRequest)

  landingContext.setLoadingInfo('Lookup vin', vinIsFetching)
  const vinNoError = !vinIsFetching && vinErrors && !!vinErrors.length && vinErrors[0] !== 200001
  const vehicleActivityApplicationDown = !vinIsFetching && vinErrors && !!vinErrors.length && vinErrors[0] === 200001
  const autoCheckData = posData && !vinIsFetching && posData.autoCheckData
  const isAssigned = landingContext.experienceState && landingContext.experienceState.isAssigned
  const isCobrand = landingContext.experienceState && landingContext.experienceState.isCobrand
  const isLandingWebComponent = landingContext.experienceState && landingContext.experienceState.isLandingWebComponent
  const allowIneligibleVehiclesCobranding = landingContext.experienceState.allowIneligibleVehicle && isCobrand
  const isAssignedOrCobranding = isAssigned || allowIneligibleVehiclesCobranding
  const allowIneligibleVehiclesFlow = isLandingWebComponent ? isAssignedOrCobranding : isAssigned
  const isIneligibleVehiclesEnabled = landingContext.experienceState && landingContext.experienceState.isIneligibleVehiclesEnabled
  const vehicleIntoAuction = (!vinIsFetching && vinErrors && !!vinErrors.length && vinErrors[0] === 400031) || (autoCheckData && (isIneligibleVehiclesEnabled ? !allowIneligibleVehiclesFlow : true) && !autoCheckData.isAutoCheckEligible)

  const possibilities = posData && !vinIsFetching && posData.possibilities

  const getOnlyTrim = () => possibilities && possibilities.length === 1 && possibilities[0].trim && possibilities[0].trim.trimId
  const urlStatePos = possibilities && possibilities.length && possibilities.find(pos => (pos.trim && pos.trim.trimId) === +trim)
  const trimFromUrl = getMatchingTrim(possibilities, landingContext.urlState.trimName)
  const currentTrim = (urlStatePos && urlStatePos.trim && urlStatePos.trim.trimId) || getOnlyTrim() || trimFromUrl?.trimId || undefined //dont keep this as null initially or it will cause unnecessary effects
  
  useEffect(() => {
    if (vin && posData && !vinIsFetching) {
      const trims = posData.possibilities && posData.possibilities.length && posData.possibilities.map(pos => pos.trim)
      const vinData = posData.possibilities && posData.possibilities.length && (posData.possibilities.find(pos => (pos.trim && pos.trim.trimId) === currentTrim) || { ...posData.possibilities[0], trim: undefined } || {})
      if (vinData && vinData.colors && vinData.colors.length) vinData.colors.forEach(color => (color.colorId = color.optionId))
      setVinResults({ vin, ...vinData, trims, vehicleActivityApplicationDown })
      vinData &&
        setCadsFlags({
          cadsUsed: vinData.cadsUsed,
          transmissionsVinVerified: vinData.transmissionsVinVerified,
          enginesVinVerified: vinData.enginesVinVerified,
          drivetrainsVinVerified: vinData.drivetrainsVinVerified,
          optionsVinVerified: vinData.optionsVinVerified,
          colorsVinVerified: vinData.colorsVinVerified
        })
    }
    if (!posData || vinIsFetching) {
      setVinResults(undefined)
      setCadsFlags(undefined)
    }
  }, [vin, posData, vinIsFetching, currentTrim, submitVinCount])

  useEffect(() => {
    if (vin && posData && !vinIsFetching && !fromPlate) {
      const yearParam = posData.possibilities[0]?.year?.yearId || landingContext.yearParam
      const isIneligibleYear = checkIneligibleYear(yearParam)
      updateGlobalState({ isIneligibleYear })
      if (!isIneligibleYear) {
        updateGlobalState({ fireAnalytics: 'continue_timbuybkhome_selltrade_vin' })
      } else {
        updateGlobalState({ tagVmEligible: false })
      }
    }
  }, [vin, posData, vinIsFetching, updateGlobalState])

  return { vinResults, vinNoError, vinIsFetching, vehicleIntoAuction, autoCheckData, cadsFlags, vinActiveDealer, vinActiveDealerIsFetching, vehicleTypical }
}
